import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateContactInfo } from '@/modules/partner/actions/async/updateContactInfo';
import { TUpdateContactInfoForm } from '@/modules/partner/model';
import { getPartner } from '@/modules/partner/store/selectors';
import { AppDispatch } from '@/root-store';
import { getCodeAndNumberFromPhone } from '@/shared/utils/phoneUtils';
import { useForm } from '@/shared/view/Form';

import { EditContactView } from './view';

interface IProps {
  onGoBack: () => void;
}

const LegacyEditContactInfo = ({ onGoBack }: IProps) => {
  const dispatch = useDispatch() as AppDispatch;

  const partner = useSelector(getPartner);

  const postForm = useCallback(
    async (formValues: Parameters<typeof updateContactInfo>[0]) => {
      const { isSucceed, result = {} } = await dispatch(updateContactInfo(formValues)).unwrap();

      if (isSucceed && !result.validationErrors && !result.baseErrors) {
        onGoBack();
      }

      return result;
    },
    [dispatch, onGoBack],
  );

  const { number, code } = getCodeAndNumberFromPhone(partner.phone);

  const {
    handleSubmit,
    form: {
      control,
      formState: { isSubmitting },
    },
  } = useForm<TUpdateContactInfoForm>({
    onSubmit: postForm,
    defaultValues: {
      phoneNumber: number,
      phoneCode: code,
    },
  });

  return (
    <EditContactView
      control={control}
      isSubmitting={isSubmitting}
      onSubmit={handleSubmit}
      onGoBack={onGoBack}
    />
  );
};

export { LegacyEditContactInfo };
